const Vue = require('vue').default
const VueAwesomeSwiper = require('vue-awesome-swiper')
const moment = require("moment")
const axios = require("axios").default
const QueryString = require('../lib/QueryString').default;


Vue.use(VueAwesomeSwiper)

var PageWork = {
  data: function () {
    return {
      works_5: [],
      works: [],
      wp:[],
      enablePager: true,
      qs: QueryString.parse(),
      pageIndex: QueryString.parse().pg || 1,
      showLength: 10,
      searchQueryObj: {},
      emptyMessage: '記事がありません',
      pager: [],
      datasource: [],
      params: ''
    }
  },
  computed:{
    pageResult: function () {
      var self = this
      var index = self.showLength * (self.pageIndex - 1)
      var length = self.showLength
      var __result = [];
      for (var i = index; i < index + length && i < self.datasource.length; i++) {
        __result.push(self.datasource[i])
      }
      // console.log(self.datasource.length)
      return __result;
    }
  },
  created() {
    // axios.get('/2021_chugoku/cms/work_calendar.json').then( (res)=> {
    //   this.works_5 = res.data.slice(0,5)
    //   this.works = res.data
    //   // console.log(this.works_5)
    //   this.datasource = this.works
    //   console.log(this.datasource)
    // })

    // if (QueryString.parse().pagerDebug) {
    //   for (var i=0;i<4;i++) {
    //     this.informations = this.informations.concat(this.informations)
    //   }
    // }
    // console.log(this.works)
    // this.datasource = this.informations
  },
  mounted: function () {
    var self = this

    this.params = QueryString.parse()

    //未定義のカテゴリーではリダイレクト
    if (this.params.category && ['suita', 'takarazuka', 'koube', 'others'].indexOf(this.params.category) == -1) {
      location.replace('./');
    }
    
    axios.get('/2021_chugoku/cms/work_calendar.json?t=' + (new Date()).getTime()).then( (res)=> {
      
      this.works_5 = res.data.slice(0,5)
      this.works = res.data

      if(['suita', 'takarazuka', 'koube'].indexOf(this.params.category) > -1){
        this.datasource = this.works.filter(function(w)  {
          console.log(w.custom.radio , self.params.category)
          return w.custom.radio == self.params.category
        })
      }　else if (this.params.category == 'others') {
        this.datasource = this.works.filter(function(w)  {
          return w.custom.radio == null || w.custom.radio == self.params.category
        })
      } else {
        this.datasource = this.works
      }
      
      // for(var i = 0; i< 10; i++){
      //   this.datasource = this.datasource.concat(this.datasource)
      // }

      if (this.enablePager) this.pager = this.createPagerHTML()

    })
    var nav = this.$refs.navScroll
    nav.scrollLeft = 177
    
  },

  methods: {
    updateHistory: function () {
        var self = this;
        // ブラウザバック対応
        if (history.replaceState) {
          var historyQuery = QueryString.stringify(self.searchQueryObj);
          history.replaceState(null, null, location.pathname + (historyQuery ? "?" + historyQuery : ""))
        }
      },
      goTo: function (pageIndex) {
        var self = this;
        self.searchQueryObj = QueryString.parse()
        if (pageIndex > 0) self.pageIndex = pageIndex;
        if (pageIndex > 1) {
          self.searchQueryObj.pg = pageIndex;
        } else {
          delete self.searchQueryObj.pg
        } // ブラウザバック対応
        self.updateHistory();
        self.pager = this.createPagerHTML()
      },
      scrollToTop: function () {
        window.scrollTo(0, 0)
      },
      createPagerHTML: function () {
        var self = this

        var ret = []

        var html = ''
        if (self.datasource.length <= self.showLength) {
          // console.log(self.datasource.length)

        } else {
          var pageCount = Math.ceil(self.datasource.length / self.showLength)

          if (self.pageIndex > 1) {
            ret.push({
              className: 'co-pagination__prev co-icon--arrow before',
              text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.95 54.92"><g id="レイヤー_2" data-name="レイヤー 2"><g id="レイヤー_1-2" data-name="レイヤー 1"><rect x="-2.53" y="12.47" width="39" height="9.01" transform="translate(16.97 -7.03) rotate(45)"/><rect x="-2.03" y="34.2" width="38.09" height="8.5" transform="translate(56.22 53.61) rotate(135)"/></g></g></svg>',
              onclick: function () {
                self.goTo(self.pageIndex - 1)
                self.scrollToTop()
              }
            })
          }

          if (pageCount <= 4) {
            for (var i = 1; i <= pageCount; i++) {
              ret.push({
                className: 'co-pagination__btn' + (self.pageIndex == i ? ' cu' : ''),
                text: i,
                onclick: (function (i) {
                  return function () {
                    self.goTo(i)
                    self.scrollToTop()
                  }
                })(i)
              })
            }
          } else if (self.pageIndex <= pageCount - 3) {
            var start = Math.max(self.pageIndex - 1, 1)
            var end = start + 2;
            for (var i = start; i <= end; i++) {
              ret.push({
                className: 'co-pagination__btn' + (self.pageIndex == i ? ' cu' : ''),
                text: i,
                onclick: (function (i) {
                  return function () {
                    self.goTo(i)
                    self.scrollToTop()
                  }
                })(i)
              })
            }
            ret.push({
              className: '',
              text: '…',
              onclick: (function (i) {
                return function () {}
              })(i)
            })
            ret.push({
              className: 'co-pagination__btn',
              text: pageCount,
              onclick: (function (i) {
                return function () {
                  self.goTo(pageCount)
                  self.scrollToTop()
                }
              })(pageCount)
            })
          } else {
            ret.push({
              className: 'co-pagination__btn',
              text: 1,
              onclick: (function (i) {
                return function () {
                  self.goTo(i)
                  self.scrollToTop()
                }
              })(1)
            })
            ret.push({
              className: '',
              text: '…',
              onclick: (function (i) {
                return function () {}
              })(i)
            })
            var end = Math.min(self.pageIndex + 1, pageCount)
            var start = end - 2;
            for (var i = start; i <= end; i++) {
              ret.push({
                className: 'co-pagination__btn' + (self.pageIndex == i ? ' cu' : ''),
                text: i,
                onclick: (function (i) {
                  return function () {
                    self.goTo(i)
                    self.scrollToTop()
                  }
                })(i)
              })
            }
          }

          if (self.pageIndex < pageCount) {
            ret.push({
              className: 'co-pagination__next co-icon--arrow after',
              text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.95 54.92"><g id="レイヤー_2" data-name="レイヤー 2"><g id="レイヤー_1-2" data-name="レイヤー 1"><rect x="-2.53" y="12.47" width="39" height="9.01" transform="translate(16.97 -7.03) rotate(45)"/><rect x="-2.03" y="34.2" width="38.09" height="8.5" transform="translate(56.22 53.61) rotate(135)"/></g></g></svg>',
              onclick: function () {
                self.goTo(self.pageIndex + 1)
                self.scrollToTop()
              }
            })
          }
        }

        return ret
      },
  }
}

module.exports = PageWork